import graphql__fb1883acf441f567d4e6 from "./__generated__/TransferAppSectionQuery.graphql.ts";import { graphql } from 'babel-plugin-relay/macro'
import { useLazyLoadQuery } from 'react-relay/hooks'
import { useAppManagementContext } from 'scenes/appManagement/context'

import { TransferAppSectionQuery } from './__generated__/TransferAppSectionQuery.graphql'
import TransferAppDestination from './TransferAppDestination'
import TransferAppDestinationSelector from './TransferAppDestinationSelector'

export const query = graphql__fb1883acf441f567d4e6

const TransferAppSection = () => {
  const { appId } = useAppManagementContext()
  const { viewer } = useLazyLoadQuery<TransferAppSectionQuery>(
    query,
    { appId },
    {
      fetchPolicy: 'store-and-network',
    },
  )

  const renderTransferContent = () => {
    if (viewer.appById?.transferRequestDestination) {
      return (
        <TransferAppDestination
          destination={viewer.appById.transferRequestDestination}
          canCancel={viewer.appById.viewerCanTransfer}
          appId={appId}
        />
      )
    }

    if (viewer.appById?.viewerCanTransfer) {
      return <TransferAppDestinationSelector appId={appId} />
    }

    const organizationOwner = viewer.appById?.tenant?.owner?.user
    const ownerName =
      organizationOwner?.firstName || organizationOwner?.lastName
        ? `${organizationOwner.firstName} ${organizationOwner.lastName}`.trim()
        : organizationOwner?.email

    return (
      <p>
        {`Use this section to transfer the app to a different user or
          organization. Only the organization owner, ${ownerName}, is
          allowed to transfer this app.`}
      </p>
    )
  }

  return (
    <div>
      <h3 className="text-lg font-medium leading-6 text-foreground-normal">
        Transfer app
      </h3>
      <p className="mt-1 text-base text-foreground-subtle">
        Transfer your app to another person or organization
      </p>
      {renderTransferContent()}
    </div>
  )
}

export default TransferAppSection
